import PropTypes from "prop-types";

import ActionPopOutOption from "@/view/ActionPopOutOption";

const propTypes = {
  contentId: PropTypes.string,
  name: PropTypes.string,
  option: PropTypes.string,
  isSelected: PropTypes.bool,
  setCurrentFontSize: PropTypes.func,
};

const FontSizeOption = ({
  name,
  option,
  isSelected,
  setCurrentFontSize,
  contentId,
}) => {
  const eventProperties = {
    actionName: "Interact",
    objectType: "Content",
    actionPrefix: "Initiate",
    streamProperties: {
      content_id: contentId,
      content_type: "Article",
      description: `Update text size to ${name}`,
    },
  };
  const dataProps = { "data-qa-selector": `set-font-size-${name}` };
  const handleSelectOption = () => {
    setCurrentFontSize(option);
  };

  return (
    <ActionPopOutOption
      dataProps={dataProps}
      eventProperties={eventProperties}
      icon={<></>}
      isSelected={isSelected}
      onClick={() => handleSelectOption()}
      title={`Text size: ${name}`}
    />
  );
};

FontSizeOption.propTypes = propTypes;
export default FontSizeOption;
